import { render, staticRenderFns } from "./NonConformityView.vue?vue&type=template&id=6f01c65c&scoped=true"
import script from "./NonConformityView.vue?vue&type=script&lang=js"
export * from "./NonConformityView.vue?vue&type=script&lang=js"
import style0 from "./NonConformityView.vue?vue&type=style&index=0&id=6f01c65c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f01c65c",
  null
  
)

export default component.exports